module.exports = __webpack_public_path__ + "img/qr-code.8e1954eb.png";